"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Brand_module_scss_1 = __importDefault(require("./Brand.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var requestBanner_1 = __importDefault(require("../../requestBanner/requestBanner"));
var BreadCrumpPage_1 = require("../../breadCrumpPage/BreadCrumpPage");
var Loader_1 = require("../../loader/Loader");
var BrandModels = function () {
    var brand = (0, react_router_dom_1.useParams)().brand;
    var _a = (0, react_1.useState)(null), carsByBrand = _a[0], setCarsByBrand = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setLoading = _b[1];
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalogs/cars_by_brand?brand_name=").concat(brand))];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        setCarsByBrand(result);
                        setLoading(false);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    return (react_1.default.createElement("div", { className: Brand_module_scss_1.default.container },
        react_1.default.createElement("div", { className: Brand_module_scss_1.default.page },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Каталог', url: '/catalog' },
                    { name: "".concat(brand), url: "/catalog/".concat(brand) },
                ] }),
            isLoading ? (react_1.default.createElement(Loader_1.Loader, null)) : (react_1.default.createElement("div", { className: Brand_module_scss_1.default.modal_card_wrapper },
                react_1.default.createElement("h2", { className: Brand_module_scss_1.default.model_card_title }, brand),
                react_1.default.createElement(requestBanner_1.default, { brand: brand }),
                react_1.default.createElement("div", { className: Brand_module_scss_1.default.model_card_list }, carsByBrand === null || carsByBrand === void 0 ? void 0 : carsByBrand.map(function (car) {
                    return (react_1.default.createElement(react_router_dom_1.Link, { to: "/catalog/".concat(car.brand, "/").concat(car.model, "_").concat(car.id), key: "".concat(car.id, "_").concat(car.brand, "_").concat(car.model), className: Brand_module_scss_1.default.model_card_container },
                        react_1.default.createElement("div", { className: Brand_module_scss_1.default.model_card_img },
                            react_1.default.createElement("img", { loading: "lazy", src: car.car_color.image, title: "".concat(car.brand, " ").concat(car.model), alt: "".concat(car.brand, " ").concat(car.model) })),
                        react_1.default.createElement("div", { className: Brand_module_scss_1.default.model_card_chars },
                            react_1.default.createElement("span", null, "".concat(!car.power ? '-' : car.power, " \u043B.\u0441.")),
                            react_1.default.createElement("span", null, "".concat(!car.acceleration ? '-' : car.acceleration, " c.")),
                            react_1.default.createElement("span", null, "".concat(!car.varumption ? '-' : car.varumption, " \u043B/\u043A\u043C"))),
                        react_1.default.createElement("h3", { className: Brand_module_scss_1.default.model_card_title }, "".concat(car.brand, " ").concat(car.model))));
                })))))));
};
exports.default = BrandModels;
